import React from 'react';
import styled, { css } from 'styled-components';
import Box from '../Box/Box.js';
import { get } from '../../constants.js';
import Text from '../Text/Text.js';
import Spacer from '../Spacer/Spacer.js';
import AtlasButton from '../AtlasButton/AtlasButton.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// @TODO: we need to stop using these explicit types and migrate to only an `onSelect` with a more loosely defined type

const variantMappingObj = {
  ['WithImage']: 'olt',
  ['NoImage']: 'olt',
  ['TwoLineTitleLeft']: 'tltl',
  ['TwoLineTitleCenter']: 'tltc',
  ['TwoColumnTitleCenter']: 'tctc'
};
const ButtonGroup = ({
  primaryAction,
  secondaryAction,
  actionHandler,
  onSelect,
  buttonAppearance = 'primary',
  linkData,
  variant = 'default',
  parentVariant = 'NoImage'
}) => {
  const testId = `hero-btn-primary-${variantMappingObj[parentVariant]}-${buttonAppearance}`;
  return /*#__PURE__*/React.createElement(React.Fragment, null, linkData ? /*#__PURE__*/React.createElement(ButtonGroupWrapper, {
    variant: variant
  }, /*#__PURE__*/React.createElement(AtlasButton, _extends({
    as: "a"
  }, linkData[0], {
    "data-testid": testId,
    appearance: buttonAppearance
  }), linkData[0].label), /*#__PURE__*/React.createElement(AtlasButton, _extends({
    as: "a"
  }, linkData[1], {
    appearance: `subtle-link`
  }), /*#__PURE__*/React.createElement(Box, {
    as: "span"
  }, /*#__PURE__*/React.createElement(SVG, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/SVG"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17H5V7H6V5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H6V17ZM19 10.005V19H9V5H14.99V7.49C14.99 7.68698 15.0288 7.88204 15.1042 8.06402C15.1796 8.24601 15.2901 8.41137 15.4293 8.55066C15.5686 8.68995 15.734 8.80044 15.916 8.87582C16.098 8.9512 16.293 8.99 16.49 8.99H20.99V8.468C20.99 8.171 20.858 7.89 20.631 7.7L15.557 3.464C15.197 3.164 14.744 3 14.275 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.005H19Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    axis: "horizontal",
    size: 4
  }), linkData[1].label)) : /*#__PURE__*/React.createElement(ButtonGroupWrapper, {
    variant: variant
  }, /*#__PURE__*/React.createElement(AtlasButton, {
    as: "a",
    href: primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.url,
    onClick: () => actionHandler ? actionHandler(primaryAction) : null,
    "data-testid": testId,
    appearance: buttonAppearance
  }, primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.label), /*#__PURE__*/React.createElement(AtlasButton, {
    as: "a",
    href: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.url,
    appearance: `subtle-link`,
    onClick: onSelect ? onSelect : undefined
  }, /*#__PURE__*/React.createElement(Box, {
    as: "span"
  }, /*#__PURE__*/React.createElement(SVG, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/SVG"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17H5V7H6V5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H6V17ZM19 10.005V19H9V5H14.99V7.49C14.99 7.68698 15.0288 7.88204 15.1042 8.06402C15.1796 8.24601 15.2901 8.41137 15.4293 8.55066C15.5686 8.68995 15.734 8.80044 15.916 8.87582C16.098 8.9512 16.293 8.99 16.49 8.99H20.99V8.468C20.99 8.171 20.858 7.89 20.631 7.7L15.557 3.464C15.197 3.164 14.744 3 14.275 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.005H19Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    axis: "horizontal",
    size: 4
  }), secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.label)));
};

// variants:
const OneLineTitle = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-testid": "hero-olt"
  }, /*#__PURE__*/React.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React.createElement(Hero, null, /*#__PURE__*/React.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block'
    }
  }, title), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React.createElement(HeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle'
    }
  }, caption), /*#__PURE__*/React.createElement(ButtonGroup, _extends({}, props, {
    parentVariant: variant === 'WithImage' && imgUrl ? 'WithImage' : 'NoImage'
  }))), variant === 'WithImage' && imgUrl && /*#__PURE__*/React.createElement(Box, {
    sx: {
      p: 1,
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    "data-testid": "hero-image-wrapper"
  }, /*#__PURE__*/React.createElement(Img, {
    src: imgUrl,
    alt: imgAlt,
    "data-testid": "hero-image"
  })))));
};
OneLineTitle.displayName = "OneLineTitle";
const TwoLineTitleLeft = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-testid": "hero-tltl"
  }, /*#__PURE__*/React.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React.createElement(Hero, null, /*#__PURE__*/React.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block'
    }
  }, title), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React.createElement(HeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle'
    }
  }, caption), /*#__PURE__*/React.createElement(ButtonGroup, _extends({}, props, {
    parentVariant: variant
  })))));
};
TwoLineTitleLeft.displayName = "TwoLineTitleLeft";
const TwoLineTitleCenter = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant = 'TwoLineTitleCenter',
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-testid": "hero-tltc"
  }, /*#__PURE__*/React.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React.createElement(CenteredHero, null, /*#__PURE__*/React.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center'
    }
  }, title), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React.createElement(CenteredHeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle'
    }
  }, caption), /*#__PURE__*/React.createElement(ButtonGroup, _extends({}, props, {
    variant: "centered",
    parentVariant: variant
  })))));
};
TwoLineTitleCenter.displayName = "TwoLineTitleCenter";
const TwoColumnTitleCenter = ({
  title,
  subtitle,
  subtitleSolidColor,
  caption,
  imgUrl,
  imgAlt,
  variant = 'TwoColumnTitleCenter',
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    as: "div",
    "data-testid": "hero-2coltc"
  }, /*#__PURE__*/React.createElement(Section, {
    "data-testid": "hero-component"
  }, /*#__PURE__*/React.createElement(ResponsiveGridBox, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(CenteredHero, null, /*#__PURE__*/React.createElement(Spacer, {
    axis: "vertical",
    size: 32
  }), /*#__PURE__*/React.createElement(HeroTitle, {
    as: "h1",
    sx: {
      color: 'text.default'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center'
    }
  }, title), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      textAlign: 'center',
      marginTop: '8px',
      color: subtitleSolidColor
    }
  }, subtitle)), /*#__PURE__*/React.createElement(CenteredHeroCaption, {
    as: "p",
    sx: {
      color: 'text.subtle',
      marginTop: '0!important'
    }
  }, caption))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(ButtonGroup, _extends({}, props, {
    variant: "centered",
    parentVariant: variant
  }))))));
};
TwoColumnTitleCenter.displayName = "TwoColumnTitleCenter";
const Wrapper = styled(Box).withConfig({
  displayName: "PageHero__Wrapper",
  componentId: "sc-1qxyglb-0"
})(["position:relative;"]);
const Section = styled.section.withConfig({
  displayName: "PageHero__Section",
  componentId: "sc-1qxyglb-1"
})(["margin-left:auto;margin-right:auto;position:relative;display:flex;flex-direction:column;gap:", ";justify-content:space-between;align-items:center;@media (min-width:", "){}@media (min-width:", "){flex-direction:row;}@media (min-width:", "){}@media (min-width:", "){}"], get('space.5'), get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'), get('breakpoints.3'));
const Hero = styled.div.withConfig({
  displayName: "PageHero__Hero",
  componentId: "sc-1qxyglb-2"
})(["display:flex;flex-direction:column;flex:1;text-align:center;gap:", ";@media (min-width:", "){text-align:revert;padding:revert;}@media (min-width:", "){text-align:left;}"], get('space.1'), get('breakpoints.0'), get('breakpoints.1'));
const CenteredHero = styled(Hero).withConfig({
  displayName: "PageHero__CenteredHero",
  componentId: "sc-1qxyglb-3"
})(["text-align:center;"]);
const HeroTitle = styled(Text).withConfig({
  displayName: "PageHero__HeroTitle",
  componentId: "sc-1qxyglb-4"
})(["font-size:", "rem;font-weight:700;letter-spacing:-0.025em;@media (min-width:", "){font-size:", "rem;line-height:1;}@media (min-width:", "){font-size:", "rem;line-height:1;}"], 29 / 16, get('breakpoints.0'), 29 / 16, get('breakpoints.1'), 38 / 16);
const HeroCaption = styled(Text).withConfig({
  displayName: "PageHero__HeroCaption",
  componentId: "sc-1qxyglb-5"
})(["margin-top:", ";font-size:", ";font-weight:", ";line-height:", ";margin-left:auto;margin-right:auto;@media (min-width:", "){width:clamp(375px,65%,480px);margin-left:revert;margin-right:revert;}@media (min-width:", "){margin-left:revert;margin-right:revert;}"], get('space.2'), get("fontSizes.3"), get('fontWeights.normal'), get('lineHeights.default'), get('breakpoints.0'), get('breakpoints.1'));
const CenteredHeroCaption = styled(HeroCaption).withConfig({
  displayName: "PageHero__CenteredHeroCaption",
  componentId: "sc-1qxyglb-6"
})(["margin-left:auto;margin-right:auto;margin-top:", ";"], get('space.4'));
const ButtonWrapper = styled.div.withConfig({
  displayName: "PageHero__ButtonWrapper",
  componentId: "sc-1qxyglb-7"
})(["margin-top:", ";font-size:", ";display:flex;flex-direction:column;justify-content:center;flex:1;gap:8px;padding:0 8px;@media (min-width:", "){padding:revert;display:flex;justify-content:flex-start;flex-direction:row;}@media (min-width:", "){justify-content:start;}"], get('space.5'), get("fontSizes.3"), get('breakpoints.0'), get('breakpoints.1'));
const ButtonGroupWrapper = styled(ButtonWrapper).withConfig({
  displayName: "PageHero__ButtonGroupWrapper",
  componentId: "sc-1qxyglb-8"
})(["", ""], props => {
  return props.variant === 'centered' ? css(["justify-content:center;align-items:center;@media (min-width:", "){justify-content:center;align-items:center;}@media (min-width:", "){justify-content:center;align-items:center;}"], get('breakpoints.0'), get('breakpoints.1')) : ``;
});
const ImageWrapper = styled(Box).withConfig({
  displayName: "PageHero__ImageWrapper",
  componentId: "sc-1qxyglb-9"
})(["flex:1;margin-top:24px;display:flex;justify-content:center;img{max-width:100%;}@media (min-width:", "){}@media (min-width:", "){margin-top:revert;}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const Img = styled.img.withConfig({
  displayName: "PageHero__Img",
  componentId: "sc-1qxyglb-10"
})(["width:100%;object-fit:cover;height:16rem;@media (min-width:", "){height:18rem;}@media (min-width:", "){}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'));
const SVG = styled.svg.withConfig({
  displayName: "PageHero__SVG",
  componentId: "sc-1qxyglb-11"
})(["display:block;user-select:none;overflow:visible;"]);
const ResponsiveGridBox = styled(Box).withConfig({
  displayName: "PageHero__ResponsiveGridBox",
  componentId: "sc-1qxyglb-12"
})(["display:flex;flex-wrap:wrap;@media (min-width:", "){}@media (min-width:", "){display:grid;grid-template-columns:1fr 1fr;align-items:center;justify-items:center;gap:", ";flex:1;}@media (min-width:", "){}"], get('breakpoints.0'), get('breakpoints.1'), get('space.3'), get('breakpoints.2'));
const variantsObj = {
  ['WithImage']: OneLineTitle,
  ['NoImage']: OneLineTitle,
  ['TwoLineTitleLeft']: TwoLineTitleLeft,
  ['TwoLineTitleCenter']: TwoLineTitleCenter,
  ['TwoColumnTitleCenter']: TwoColumnTitleCenter
};

/**
 * The `PageHero` component is a general purpose hero component that renders a responsive, mobile-first hero with or without an accompanying image.
 *
 * If no image URL is passed, the "NoImage" variant will be rendered.
 *
 * Every `PageHero` variant should display a `primary` and `secondary` action, but there are several layout options available.
 *
 * **Layout Variants**:
 *
 * * **"WithImage"**: Default `PageHero` configuration. Left-aligned title and a caption with action buttons aligned in a column on the left, and a large image on the right at standard laptop and desktop viewport sizes.
 * Centered with image below at mobile viewport sizes.
 *
 * * **"NoImage"**: A left-aligned title and a caption with action buttons aligned in a column on the left at standard laptop and desktop viewport sizes.
 * Centered at mobile viewport sizes.
 *
 * * **"TwoLineTitleLeft"**: A left-aligned title and a second line for the title via the `subtitle` prop, with caption and action buttons aligned in a column on the left at standard laptop and desktop viewport sizes.
 * Centered at mobile viewport sizes. Optional emphasis color can be added to `subtitle` prop.
 *
 * * **"TwoLineTitleCenter"**: A center-aligned title and subtitle, with caption and action buttons aligned in a column at all viewport sizes.
 *
 * * **"TwoColumnTitleCenter"**: A two-column hero layout with no image, a center-aligned title and subtitle, and caption and action buttons aligned in a column at all viewport sizes.
 *
 */
const PageHero = ({
  variant = 'WithImage',
  buttonAppearance = 'primary',
  ...props
}) => {
  const Component = variantsObj[variant];
  return /*#__PURE__*/React.createElement(Component, _extends({
    variant: variant,
    buttonAppearance: buttonAppearance
  }, props));
};
PageHero.displayName = "PageHero";
var PageHero$1 = PageHero;

export { PageHero$1 as default };
